module.exports = __webpack_public_path__ + "img/_circle-blue2.f9e449c0.svg";